import * as React from 'react';
import classNames from 'classnames';
import BaseSectionWithAnalyticsContext from '../../common/BaseSection/BaseSectionWithAnalyticsContext.esm.js';
import { ExtraLargeImageContext } from '../../common/ContentfulImage/ExtraLargeImageContext.esm.js';
import { NvMarkdownInline, NvMarkdown } from '@invitae/ids-react';
import { BaseNucleobaseComponent } from '@invitae/nucleobase-core';
import styles from './HeroBoxBlock.module.esm.js';

var HeroBoxBlock = function (_a) {
    var _b = _a.fields, body = _b.body, heading = _b.heading, image = _b.image, link = _b.link, subheading = _b.subheading, textPosition = _b.textPosition, internalName = _b.internalName, analyticsEvents = _b.analyticsEvents, id = _a.id, dataCy = _a["data-cy"];
    var className = classNames(styles.root, 'nv-container', styles[textPosition]);
    return (React.createElement(BaseSectionWithAnalyticsContext, { analyticsEvents: analyticsEvents, className: className, "data-cy": dataCy, id: id, sectionName: internalName },
        React.createElement(ExtraLargeImageContext, null,
            React.createElement(BaseNucleobaseComponent, { alt: "", source: image })),
        React.createElement("div", { className: classNames(styles.text, styles[textPosition]) },
            React.createElement(NvMarkdownInline, { className: styles.heading, elementWrapper: "h2" }, heading),
            subheading && (React.createElement(NvMarkdownInline, { className: styles.subheading, elementWrapper: "p" }, subheading)),
            body && React.createElement(NvMarkdown, null, body),
            link && (React.createElement(React.Fragment, null,
                React.createElement(BaseNucleobaseComponent, { source: link }),
                React.createElement("div", { className: styles.linkOverlay },
                    React.createElement(BaseNucleobaseComponent, { source: link })))))));
};

export { HeroBoxBlock as default };
//# sourceMappingURL=HeroBoxBlock.esm.js.map
